export enum RoleEnum {
  user = 'user',
  companyUser = 'companyUser',
  superAdmin = 'superAdmin',
}
